import * as React from 'react';
import { removeDiacriticsToLower } from '../../../../utilities';

interface IconProps {
  className?: string;
}

const svg = (children: React.ReactNode): React.FC<IconProps> => ({
  className,
}) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {children}
  </svg>
);

const s = {
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

const DiscountIcon = svg(
  <>
    <path
      d="M3.5 8.6 8.6 3.5a2 2 0 0 1 2.3-.4l1.9.9 2 .3a2 2 0 0 1 1.7 1.7l.3 2 .9 1.9a2 2 0 0 1-.4 2.3l-5.1 5.1a2 2 0 0 1-2.3.4l-1.9-.9-2-.3a2 2 0 0 1-1.7-1.7l-.3-2-.9-1.9a2 2 0 0 1 .4-2.3Z"
      fill="currentColor"
    />
    <circle cx="9.7" cy="9.7" r="1.15" fill="#fff" />
    <circle cx="14.3" cy="14.3" r="1.15" fill="#fff" />
    <path
      d="M9.2 14.8 14.8 9.2"
      stroke="#fff"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </>,
);

const ArtIcon = svg(
  <>
    <path d="M14.5 4.5 19.5 9.5 9 20H4v-5L14.5 4.5Z" {...s} />
    <path d="M12.5 6.5 17.5 11.5" {...s} />
  </>,
);

const PenIcon = svg(
  <>
    <path d="M4 20l1-4L15.5 5.5a2 2 0 0 1 3 3L8 19l-4 1Z" {...s} />
    <path d="M13.5 7.5 16.5 10.5" {...s} />
  </>,
);

const OfficeIcon = svg(
  <>
    <rect x="4" y="7" width="16" height="13" rx="2" {...s} />
    <path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2M4 12h16" {...s} />
  </>,
);

const HouseIcon = svg(
  <>
    <path
      d="M4 10.5 12 4l8 6.5V19a1 1 0 0 1-1 1h-4v-5H9v5H5a1 1 0 0 1-1-1v-8.5Z"
      {...s}
    />
  </>,
);

const CakeIcon = svg(
  <>
    <path d="M4 20h16M5 20v-7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7" {...s} />
    <path
      d="M4 14c1.3 0 1.3 1.2 2.7 1.2S8 14 9.3 14s1.4 1.2 2.7 1.2S13.3 14 14.7 14 16 15.2 17.3 15.2 18.7 14 20 14"
      {...s}
    />
    <path d="M12 8V6M9 8V6.5M15 8V6.5" {...s} />
  </>,
);

const DrugstoreIcon = svg(
  <>
    <path d="M9 8h6v10a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V8Z" {...s} />
    <path d="M10 8V5h4v3M11 12h2" {...s} />
  </>,
);

const PhotoIcon = svg(
  <>
    <rect x="3.5" y="5.5" width="17" height="13" rx="2" {...s} />
    <circle cx="8.5" cy="10" r="1.4" {...s} />
    <path d="M4 17l4.5-4 3 2.5L15 11l5 4.5" {...s} />
  </>,
);

const PartyIcon = svg(
  <>
    <path
      d="M12 3.5l2.2 4.4 4.8.7-3.5 3.4.8 4.8L12 14.5l-4.3 2.3.8-4.8L5 8.6l4.8-.7L12 3.5Z"
      {...s}
    />
  </>,
);

const GiftIcon = svg(
  <>
    <rect x="4" y="9" width="16" height="4" rx="1" {...s} />
    <path d="M5 13h14v6a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-6ZM12 9v11" {...s} />
    <path
      d="M12 9C12 9 8 9 8 6.5 8 5.1 9.1 4 10.5 4 12 4 12 9 12 9ZM12 9s4 0 4-2.5C16 5.1 14.9 4 13.5 4 12 4 12 9 12 9Z"
      {...s}
    />
  </>,
);

const ChairIcon = svg(
  <>
    <path d="M7 4h7a2 2 0 0 1 2 2v6H7V4Z" {...s} />
    <path d="M7 12h9M6 12v8M17 12v8M6 16h11" {...s} />
  </>,
);

const TagIcon = svg(
  <>
    <path d="M4 4h7l9 9-7 7-9-9V4Z" {...s} />
    <circle cx="8" cy="8" r="1.3" {...s} />
  </>,
);

const RULES: Array<{ kw: string[]; Icon: React.FC<IconProps> }> = [
  { kw: ['akcia', 'novink', 'zlava', 'sezon'], Icon: DiscountIcon },
  { kw: ['skolsk', 'vytvarn', 'tvoriv', 'kreativ'], Icon: ArtIcon },
  { kw: ['pisanie', 'pero'], Icon: PenIcon },
  { kw: ['kancelaria', 'kancelar'], Icon: OfficeIcon },
  { kw: ['domacnost', 'domov'], Icon: HouseIcon },
  { kw: ['pecenie', 'kuchyn', 'varenie'], Icon: CakeIcon },
  { kw: ['drogeria', 'hygien', 'cisten'], Icon: DrugstoreIcon },
  { kw: ['foto', 'fotograf'], Icon: PhotoIcon },
  { kw: ['party', 'oslav'], Icon: PartyIcon },
  { kw: ['darcek', 'hry', 'hrack'], Icon: GiftIcon },
  { kw: ['nabytok', 'vybaven', 'stolick'], Icon: ChairIcon },
];

export function getCategoryIcon(name: string): React.FC<IconProps> {
  const n = removeDiacriticsToLower(name || '');
  for (const rule of RULES) {
    if (rule.kw.some((k) => n.indexOf(k) !== -1)) {
      return rule.Icon;
    }
  }
  return TagIcon;
}
